<app-info-page
  title="Cómo funciona"
  [subtitle]="subtitle"
  [videoSrc]="videoSrc"
  [imageSrc]="imageSrc"
  [imageAlt]="imageAlt"
>
  <p class="info-card__text" [innerHTML]="text | nl2br">
  </p>
</app-info-page>
